import styled from 'styled-components';

export const CardContainer = styled.div`
  flex: 0 0 auto;
  width: 200px;
  max-width: 220px;
  background-color: black;
  color: white;
  border-radius: 12px;
  cursor: pointer;
  overflow: hidden;
  padding-bottom: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: 768px) {
    width: 160px;
  }

  @media (max-width: 480px) {
    width: 140px;
  }

  &:hover {
    transform: scale(1.05);
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 180px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    height: 140px;
  }

  @media (max-width: 480px) {
    height: 120px;
  }
`;

export const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Tag = styled.div`
  position: absolute;
  top: 75%;
  left: 0;
  background-color: #92b21f;
  color: white;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 0 6px 6px 0;
  font-size: 12px;

  box-shadow: 0 0 8px rgba(146, 178, 31, 0.6) @media (max-width: 480px) {
    font-size: 10px;
    padding: 2px 6px;
  }
`;

export const ProductInfo = styled.div`
  padding: 8px;
  width: 100%;
  text-align: center;
`;

export const ProductName = styled.p`
  font-weight: bold;
  font-size: 16px;
  line-height: 1.2;
  margin: 4px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.4em; /* força 2 linhas mesmo se tiver pouco texto */

  @media (max-width: 768px) {
    font-size: 14px;
    min-height: 2.4em;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    min-height: 2.4em;
  }
`;

export const Price = styled.p`
  font-size: 18px;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const PromoPrice = styled.p`
  font-size: 14px;
  color: #ccc;
  margin-top: 4px;
  min-height: 20px; /* força alinhamento vertical mesmo vazio */

  @media (max-width: 768px) {
    font-size: 12px;
    min-height: 18px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
    min-height: 16px;
  }
`;

export const WhatsButton = styled.button`
  margin-top: 10px;
  background-color: #92b21f;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
  justify-self: center;

  @media (max-width: 480px) {
    font-size: 12px;
    padding: 8px 12px;
  }

  &:hover {
    background-color: #7da51c;
  }
`;
